export default __webpack_public_path__ + "static/media/same-window.99f455c4.svg";